import { UpdateMyAccountInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const UpdateMyAccountInputSchema: z.ZodType<UpdateMyAccountInput> =
  z.object({
    name: z.string(),
    country_code: z.string(),
    phone: z.string(),
  });
